import { Box, Flex, Image } from '@chakra-ui/react';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { BrandAssets } from 'src/config';
import { Color } from 'src/theme/color';
import { colors } from 'src/utils/colors';
import { HamburgerRedIcon } from 'src/utils/icons/hamburger_red';
import { LanguageSelect } from '../common/LanguageSelect/languageSelect';
import { ContractHelper } from './ContractHelper/contractHelper';
import { HashupInfo } from './HashupInfo/hashupInfo';
import { WalletElement } from './walletElement';

interface HeaderProps {
	onOpenMobileMenu: () => void;
}

export const Header: FC<HeaderProps> = ({ onOpenMobileMenu }) => {
	return (
		<>
			{/* dekstop */}
			<Flex
				display={{ base: 'none', md: 'flex' }}
				justifyContent="space-between"
				padding="5px 0px"
				borderBottom={`1px solid ${Color.GRAY_1}`}
			>
				<Flex
					gridGap="20px"
					alignItems="center"
				>
					<HashupInfo />
					<Box
						height="14px"
						width="1px"
						bg={colors.primary}
					/>
					<ContractHelper />
					{/*<AddToMetamask />*/}
				</Flex>
				<Flex>
					<LanguageSelect
						onClickEvent={(event: any) => {
							event.stopPropagation();
						}}
					/>
				</Flex>
			</Flex>
			{/* mobile */}
			<Box
				display={{ base: 'block', md: 'none' }}
				p="18px"
				borderBottom={`1px solid ${colors.darkGray}`}
			>
				<Flex
					alignItems="center"
					justifyContent="space-between"
					gridGap="28px"
					fontSize="12px"
					lineHeight="15px"
					padding="8px 0px"
				>
					<Flex display={{ base: 'flex', lg: 'none' }}>
						<HamburgerRedIcon onClick={onOpenMobileMenu} />
					</Flex>
					<Flex
						cursor="pointer"
						display={{ base: 'flex', lg: 'none' }}
					>
						<Link to="/">
							<Image
								w="200px"
								src={BrandAssets.logo}
							/>
						</Link>
					</Flex>
					<Flex display={{ base: 'flex', md: 'none' }}>
						<WalletElement isMobile />
					</Flex>
				</Flex>
			</Box>
		</>
	);
};
